<template>
  <section class="funding-section" aria-labelledby="funding-heading">
    <div class="funding-header">
      <div
        class="funding-icon"
        v-html="LAPTOP_ICON_SVG"
        aria-hidden="true"
      ></div>
      <div class="funding-heading-row">
        <h2 id="funding-heading" class="funding-title">
          Planning &amp; Funding Support
        </h2>
        <p class="funding-intro">
          You can write to us via email or call us directly for further
          information.
        </p>
      </div>
    </div>

    <div class="funding-body">
      <div class="funding-visual">
        <img
          src="/images/maker-cart/get-started/planning-funding-illustration.svg"
          alt=""
          class="funding-visual__image"
          width="427"
          height="433"
          aria-hidden="true"
        />
      </div>

      <div class="funding-details">
        <div class="funding-resources">
          <p class="funding-resource">
            Need funding? Access grant templates and funding resources at our
            <a
              class="funding-resource__link"
              href="https://grants.edm8ker.com/"
              target="_blank"
              rel="noopener noreferrer"
              >Grant Support Portal</a
            ><span class="funding-resource__link">.</span>
          </p>
          <p class="funding-resource">
            Looking for brochures? Download catalogs and program guides via our
            <a
              class="funding-resource__link"
              href="https://linktr.ee/edm8ker"
              target="_blank"
              rel="noopener noreferrer"
              >Digital Resource Hub</a
            ><span class="funding-resource__link">.</span>
          </p>
        </div>

        <div class="funding-divider" aria-hidden="true"></div>

        <ul class="funding-contacts">
          <li
            v-for="item in contacts"
            :key="item.label"
            class="funding-contact"
          >
            <ArrowShortRightIcon color="#003d6a" />
            <a
              :href="item.href"
              class="funding-contact__link"
              :aria-label="item.ariaLabel"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ArrowShortRightIcon } from "@/components/icons";

const contacts = [
  {
    label: "Email: hello@edm8ker.com",
    href: "mailto:hello@edm8ker.com",
    ariaLabel: "Email hello@edm8ker.com",
  },
  {
    label: "Phone (US Region): +1 (646) 335 3297",
    href: "tel:+16463353297",
    ariaLabel: "Call US region: +1 646 335 3297",
  },
  {
    label: "Phone (SG Region): +65 8920 9149",
    href: "tel:+6589209149",
    ariaLabel: "Call SG region: +65 8920 9149",
  },
];

const LAPTOP_ICON_SVG = `<svg width="68" height="51" viewBox="0 0 68 51" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.666687 44C0.666687 42.159 2.15907 40.6666 4.00002 40.6666H64C65.841 40.6666 67.3334 42.159 67.3334 44V47.3333C67.3334 49.1742 65.841 50.6666 64 50.6666H4.00002C2.15907 50.6666 0.666687 49.1742 0.666687 47.3333V44Z" fill="#E00069"/>
  <path d="M64 40.6666V40.9049C63.9999 42.6142 62.5077 43.9995 60.667 43.9996H7.33301C5.49228 43.9995 4.00011 42.6142 4 40.9049V40.6666H64ZM20.5664 0.666626C22.133 0.666626 23.4358 1.91968 24.6777 2.87463C25.3986 3.42885 26.324 3.76226 27.333 3.76233H40.667C41.676 3.76226 42.6014 3.42885 43.3223 2.87463C44.5642 1.91968 45.867 0.666626 47.4336 0.666626H60.667C62.5078 0.66679 64 2.05298 64 3.76233V35.6666H4V3.76233C4 2.05298 5.49221 0.666789 7.33301 0.666626H20.5664Z" fill="#E00069"/>
</svg>`;
</script>

<style scoped>
.funding-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 40px 0;
}

.funding-header {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.funding-icon {
  display: flex;
  justify-content: left;
  width: 100%;
  height: 80px;
}

.funding-heading-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}

.funding-title {
  flex: 1;
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-display-small);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-display-small);
  color: var(--blue-dark-2);
}

.funding-intro {
  flex: 0 0 628px;
  max-width: 628px;
  margin: 0;
  text-align: right;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-title-large);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-title-large);
  color: var(--black-body-text);
}

.funding-body {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  width: 100%;
}

.funding-visual {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: center;
  width: 620px;
  max-width: 100%;
  height: 443px;
  overflow: hidden;
  background-color: #56b693;
  border-radius: 24px;
  box-sizing: border-box;
  padding: 24px 24px 0;
}

.funding-visual__image {
  display: block;
  width: 427px;
  max-width: 100%;
  height: auto;
}

.funding-details {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  align-self: stretch;
}

.funding-resources {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.funding-resource {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-headline-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-headline-small);
  color: var(--black-body-text);
}

.funding-resource__link {
  color: var(--primary-pink);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.funding-resource__link:focus-visible {
  outline: 3px solid var(--primary-pink);
  outline-offset: 2px;
  border-radius: 2px;
}

.funding-divider {
  width: 100%;
  border-bottom: 1px dashed var(--blue-light-2);
}

.funding-contacts {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.funding-contact {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.funding-contact :deep(svg) {
  flex-shrink: 0;
}

.funding-contact__link {
  color: var(--black-body-text);
  font-family: var(--font-family-primary);
  font-size: var(--font-size-title-big);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-title-big);
  letter-spacing: 0.03px;
  text-decoration: none;
}

.funding-contact__link:hover {
  text-decoration: underline;
}

.funding-contact__link:focus-visible {
  outline: 3px solid var(--primary-blue);
  outline-offset: 2px;
  border-radius: 2px;
}

@media (max-width: 1200px) {
  .funding-intro {
    flex: 1;
    max-width: none;
  }

  .funding-visual {
    width: min(100%, 620px);
  }
}

@media (max-width: 992px) {
  .funding-heading-row {
    flex-direction: column;
    gap: 16px;
  }

  .funding-intro {
    text-align: left;
  }

  .funding-body {
    flex-direction: column;
    align-items: stretch;
  }

  .funding-visual {
    width: 100%;
    height: auto;
    min-height: 320px;
  }
}

@media (max-width: 768px) {
  .funding-section {
    gap: 24px;
    padding: 16px 0;
  }

  .funding-icon {
    height: 40px;
  }

  .funding-icon :deep(svg) {
    width: auto;
    height: 40px;
  }

  .funding-heading-row {
    gap: 12px;
  }

  .funding-title {
    font-size: var(--font-size-title-large);
    line-height: var(--line-height-title-large);
  }

  .funding-intro {
    font-size: var(--font-size-body-medium);
    line-height: var(--line-height-body-medium);
    letter-spacing: 0.035px;
  }

  .funding-body {
    gap: 16px;
  }

  .funding-visual {
    height: 263px;
    min-height: 0;
    align-items: center;
    padding: 14px;
    border-radius: 14px;
  }

  .funding-visual__image {
    width: auto;
    height: 100%;
    max-height: 255px;
  }

  .funding-resource {
    font-size: var(--font-size-title-large);
    line-height: var(--line-height-title-large);
  }

  .funding-contact__link {
    font-size: var(--font-size-title-medium);
    line-height: var(--line-height-title-medium);
    letter-spacing: 0.024px;
  }
}
</style>
